import styles from './PoleEducation.module.css'

const PoleEducation = () => (
  <>
    <header className={styles.header}>
      <div className={styles.contentContainer}></div>
    </header>
  </>
)

export default PoleEducation
